export default __webpack_public_path__ + "static/media/login-bg.dfd17b48.png";